import { useContext } from 'react';
import { GroupUsersContext } from '../Context';

export const useGroupUsersContext = () => {
  const ctx = useContext(GroupUsersContext);

  return ctx;
};

export default useGroupUsersContext;